'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormField = require('./FormField');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormField).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/FormField/index.js
// module id = 112
// module chunks = 0